const FASTLINKS_TIMEOUT = 10; // seconds

export default function initFastlinks(container) {
    welcomeFastlinks(container);
    fixFastlinksHeight(container);
}

function welcomeFastlinks(container) {
    if (!container.length) {
        return null;
    }

    const navPanel = $(".nav-panel", $(container).parent());
    var onPanel = false;
    if (navPanel.length > 0) {
        var display = navPanel.css("display");
        onPanel = (display != "none");
    }

    if ($(".link-item", container).length <= 1) {
        container.addClass("unslidable");
        return null;
    }

    $(".link-item", container).first().addClass("active");

    let interval;
    resetAutoplay();

    container.on("click", ".links-button-prev", function () {
        slidePrev();
        resetAutoplay();
    });

    container.on("click", ".links-button-next", function () {
        slideNext();
        resetAutoplay();
    });

    let touchStartX,
        touchEndX,
        justSlided = false;

    container.on("touchstart", function (e) {
        touchStartX = e.originalEvent.touches[0].clientX;
    });

    container.on("touchmove", function (e) {
        touchEndX = e.originalEvent.touches[0].clientX;
    });

    container.on("touchend", function (e) {
        if (touchEndX - touchStartX >= 100) {
            slidePrev();
            justSlided = true;
        }

        if (touchEndX - touchStartX <= -100) {
            slideNext();
            justSlided = true;
        }
    });

    function slidePrev() {
        var next = $(".link-item.active", container).prev();
        if (!next.length) {
            next = $(".link-item", container).last();
        }

        $(".link-item.active", container).addClass("out-prev");
        $(".link-item", container)
            .removeClass("active")
            .removeClass("active-prev")
            .removeClass("active-next");
        next.addClass("active active-prev");
    }

    function slideNext() {
        var next = $(".link-item.active", container).next();
        if (!next.length) {
            next = $(".link-item", container).first();
        }

        $(".link-item", container)
            .removeClass("active")
            .removeClass("active-prev")
            .removeClass("active-next")
            .removeClass("out-prev");
        next.addClass("active");

        if (onPanel) {
            var index = $(next).index();
            var bubble = $(".nav-bubble", navPanel).get(index);

            $(".nav-bubble", navPanel).removeClass("active");
            $(bubble).addClass("active");
        }
    }

    function resetAutoplay() {
        clearInterval(interval);
        interval = setInterval(function () {
            slideNext();
        }, FASTLINKS_TIMEOUT * 1000);
    }
}

export function fixFastlinksHeight(container)
{
    if (!container.length) {
        return;
    }

    let screenWidth = window.innerWidth;
    if (screenWidth > 780) {
        $(container).height('');
        return;
    }

    let maxContentHeight = 0;
    let maxImageHeight = 0;
    let maxLinkItemBordersHeight = 0;

    $('.link-item', container).each(function () {
        let captionHeight = $('.content-caption', this).outerHeight(true);
        let noteHeight = $('.content-note', this).outerHeight(true);
        let moreHeight = $('.content-more', this).outerHeight(true);
        let imageHeight = $('.cover-image', this).outerHeight(true);
        let borderHeight = $(this).outerHeight(true) - $(this).height();
        
        maxContentHeight = Math.max(maxContentHeight, captionHeight + noteHeight + moreHeight);
        maxImageHeight = Math.max(maxImageHeight, imageHeight);
        maxLinkItemBordersHeight = Math.max(maxLinkItemBordersHeight, borderHeight);
    })

    maxContentHeight = Math.ceil(maxContentHeight);
    maxImageHeight = Math.ceil(maxImageHeight);
    maxLinkItemBordersHeight = Math.ceil(maxLinkItemBordersHeight);

    let margin = 24;
    let containerHeight = maxContentHeight + margin + maxImageHeight + maxLinkItemBordersHeight;

    $(container).height(containerHeight);
}
